import {authenticate, AUTH} from 'src/shared/auth/actions';
import {loadUser} from 'src/shared/user/actions';
import {
  datacast,
  READ_DATACAST_COMPLETE,
} from 'src/shared/datacast/actions';
import {startDataLayerTracking} from 'src/shared/dataLayer/actions';
import {readChannelLineup} from 'src/shared/channelLineup/actions';
import {waitUntil, waitUntilOneOf} from 'src/shared/events';
import {GET_MDI_SESSION_COMPLETE} from 'src/pages/deviceInfo/store/actions/getMDISession';
import {
  GET_MDI_USER_SESSION_COMPLETE,
  readMDIUserAccountProfile,
} from 'src/pages/deviceInfo/store/actions/readMDIUserAccount';
import {maintainMDISession} from 'src/pages/deviceInfo/store/actions/maintainMDISession';
import {address} from 'src/pages/localChannelLineup/store/selectors/address';

export const start = () => async (dispatch, getState) => {
  dispatch(authenticate());
  dispatch(loadUser());
  dispatch(startDataLayerTracking());
  dispatch(datacast());
  await waitUntil(READ_DATACAST_COMPLETE);
  await waitUntil(AUTH);
  dispatch(maintainMDISession());
  await waitUntilOneOf(GET_MDI_SESSION_COMPLETE, GET_MDI_USER_SESSION_COMPLETE);
  dispatch(readMDIUserAccountProfile());
  if (address(getState())) {
    dispatch(readChannelLineup());
  }
};
